export default __webpack_public_path__ + "static/media/member_card_silver.3ae28884.png";